export function asssetNameToId(name) {
  switch (name) {
    case 'dbas': {
      return 8
    }
    case 'nav': {
      return 11
    }
  }
}

export function asssetIdToName(id) {
  switch (id) {
    case 8: {
      return 'dbas'
    }
    case 11: {
      return 'nav'
    }
  }
}

export const PageNames = {
  dbas: '信息屏左侧图',
  nav: '导航屏背景图'
}

export function assetNameToText(name) {
  switch (name) {
    case 'dbas': {
      return PageNames.dbas
    }
    case 'nav': {
      return PageNames.nav
    }
  }
}

export function supportAnimImg(routeType) {
  if (routeType === 'dbas') {
    return true
  }
  return false
}
